<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
    >
        <g clip-path="url(#clip0_8244_127570)">
            <path
                d="M2.66669 5.33464V4.0013C2.66669 3.64768 2.80716 3.30854 3.05721 3.05849C3.30726 2.80844 3.6464 2.66797 4.00002 2.66797H5.33335"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M2.66669 10.668V12.0013C2.66669 12.3549 2.80716 12.6941 3.05721 12.9441C3.30726 13.1942 3.6464 13.3346 4.00002 13.3346H5.33335"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M10.6667 2.66797H12C12.3536 2.66797 12.6928 2.80844 12.9428 3.05849C13.1929 3.30854 13.3334 3.64768 13.3334 4.0013V5.33464"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M10.6667 13.3346H12C12.3536 13.3346 12.6928 13.1942 12.9428 12.9441C13.1929 12.6941 13.3334 12.3549 13.3334 12.0013V10.668"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_8244_127570">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
